import angular from 'angular';

import component from './preferences-brand-content.component';

const PreferencesBrandContent = angular
    .module('control-room.app-settings.components.preferences-details.components.preferences-brand-content', [])
    .component('crPreferencesBrandContent', component);

export default PreferencesBrandContent;
